<template>
     <div>
        <bar  v-if="chtype == 'bar'"
              ref="chart"
              :apiData="apiData"
              :title='title'
              colorStart="#009FC5"
              colorEnd="#3CECB0"
              :legend="false"
              :loading="loading"
              ></bar>
         <x-circle v-if="chtype == 'circle'"
              ref="chart"
              :apiData="apiData"
              :title='title'
              colorStart="#009FC5"
              colorEnd="#3CECB0"
              :legend="false"
              :loading="loading"
              ></x-circle>
          <h-bar  v-if="chtype == 'hbar'"
              ref="chart"
              :apiData="apiData"
              :title='title'
              colorStart="#009FC5"
              colorEnd="#3CECB0"
              :legend="false"
              :loading="loading"
              ></h-bar>
            <x-line v-if="chtype == 'line'"
              ref="chart"
              :apiData="apiData"
              :title='title'
              colorStart="#009FC5"
              colorEnd="#3CECB0"
              :legend="false"
              :loading="loading"
              ></x-line>
            <x-pie  v-if="chtype == 'pie'"
              ref="chart"
              :apiData="apiData"
              :title='title'
              colorStart="#009FC5"
              colorEnd="#3CECB0"
              :legend="false"
              :loading="loading"
              ></x-pie>
            <x-number  v-if="chtype == 'number'"
              ref="chart"
              :apiData="apiData"
              :title='title'
              :height="200"
              colorStart="#009FC5"
              colorEnd="#3CECB0"
              :legend="false"
              :loading="loading"
              ></x-number>
          <line-area  v-if="chtype == 'linearea'"
              ref="chart"
              :apiData="apiData"
              :title='title'
              colorStart="#009FC5"
              colorEnd="#3CECB0"
              :legend="false"
              :loading="loading"
              ></line-area>
     </div>
</template>
<script>
import Bar from '@/components/page-components/chart/Bar.vue';
import Circle from '@/components/page-components/chart/Circle.vue';
import HBar from '@/components/page-components/chart/HBar.vue';
import XLine from '@/components/page-components/chart/Line.vue';
import XPie from '@/components/page-components/chart/Pie.vue';
import XNumber from '@/components/page-components/chart/Number.vue';
import LineArea from '@/components/page-components/chart/LineArea.vue';

export default {
  name: 'chartitem',
  data(){
    return {
      apiData: {columns: [], rows: []},
      chtype: ''
    }
  },
  props: {
    chartType: {
      type: String,
      required: true,
      default: ''
    },
    title: {
      type: String,
      required: true,
      default: 'Chart'
    },
    data: {
      type: Object,
      required: true,
      default: { columns: [], rows: []}
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
      Bar,
      'x-circle':Circle,
      HBar,
      XLine,
      XPie,
      XNumber,
      LineArea
  },
  watch: {
    chartType: {
        immediate: true,
        handler (val){
          this.chtype = val;
        }
    },
    data: {
      immediate: true,
      handler (val){
        this.apiData = val;
        setTimeout(()=>{
          this.moveChart();
        }, 1000);
      }
    }
  },
  mounted () {
   this.moveChart();
  },
  methods: {
    moveChart(){
    let dataIndex = -1

    if(this.chartType == 'pie' && this.$refs.chart){
      let chart = this.$refs.chart.$refs.chart;
      const dataLen = chart.options.series[0].data.length
          setInterval(() => {
            chart.dispatchAction({
              type: 'downplay',
              seriesIndex: 0,
              dataIndex
            })
            dataIndex = (dataIndex + 1) % dataLen
            chart.dispatchAction({
              type: 'highlight',
              seriesIndex: 0,
              dataIndex
            })
            // 显示 tooltip
            chart.dispatchAction({
              type: 'showTip',
              seriesIndex: 0,
              dataIndex
            })
          }, 4000)
      }
    }
  }
}

</script>
<style lang="scss" scoped>
</style>
